/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type EventList_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type HomePage_viewer$ref: FragmentReference;
declare export opaque type HomePage_viewer$fragmentType: HomePage_viewer$ref;
export type HomePage_viewer = {|
  +config: ?{|
    +frontendCarousel: ?$ReadOnlyArray<?string>
  |},
  +$fragmentRefs: EventList_viewer$ref,
  +$refType: HomePage_viewer$ref,
|};
export type HomePage_viewer$data = HomePage_viewer;
export type HomePage_viewer$key = {
  +$data?: HomePage_viewer$data,
  +$fragmentRefs: HomePage_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "HomePage_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "config",
      "storageKey": null,
      "args": null,
      "concreteType": "Config",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "frontendCarousel",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "EventList_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'bc1da70255d68f2d96c84ee749d151a0';

module.exports = node;
